import { Formik } from 'formik'
import * as React from 'react'
import Toggle from 'src/components/ui/Toggle'
import { IServicePricingType, IServicePricingTypeObject } from 'src/types'
import { sortByProperty } from 'src/utils/array-helper'

interface ServiceEditPassengerTypeProps {
  serviceId: string
  // pricingType: Array<{ serviceId: string, id: string; riderType: string; description: string; fare: number; }>
  pricingType: IServicePricingType[]
  fetchServicePricingType: (serviceId: string) => void
  fares: IServicePricingType[]
  formRef: any
  UpdateAllServicePricingType: (serviceId: string, fares: IServicePricingTypeObject) => void
  onStepSuccessfullyCompleted?: () => void
  onCreateServiceCompleted?: () => void
  handleSubmit: () => void
}

export const ServiceEditPassengerType = (props: ServiceEditPassengerTypeProps) => {
  const [fares, setFares] = React.useState([] as IServicePricingType[])

  React.useEffect(() => {
    props.fetchServicePricingType(props.serviceId)
  }, [props.serviceId])

  // set and sort service pricing
  React.useEffect(() => {
    setFares(sortByProperty(props.pricingType, 'riderType'))
  }, [props.pricingType])

  const updateFare = (newFare: number, index: number) => {
    const tempFares = [...fares]
    tempFares[index].fare = newFare
    setFares(tempFares)
  }
  const updateDescription = (description: string, index: number) => {
    const tempFares = [...fares]
    tempFares[index].description = description
    setFares(tempFares)
  }
  const toggelIsEnabled = (index: number) => {
    const tempFares = [...fares]
    tempFares[index].isActive = !tempFares[index].isActive
    setFares(tempFares)
  }
  const handleSubmit = () => {
    props.UpdateAllServicePricingType(props.serviceId, { fares })
    return props.onStepSuccessfullyCompleted && props.onStepSuccessfullyCompleted()
  }

  if (props.serviceId) {
    return (
      <div className='react-table'>
        <div className='react-table'>
          <Formik onSubmit={handleSubmit} ref={props.formRef} initialValues={{ serviceId: props.serviceId }} />
          <div className='flex col-12 mt1'>
            <span className='col-2 font-dark-grey h5 weight-500 mr2'>
              <b>Active</b>
            </span>
            <span className='col-6 font-dark-grey h5 weight-500 mr2'>
              <b>Rider Type</b>
            </span>
            <span className='col-8 font-dark-grey h5 weight-500 mr2'>
              <b>Description</b>
            </span>
            <span className='col-8 font-dark-grey h5 weight-500 mr2'>
              <b>Fare</b>
            </span>
          </div>
          {fares.map((items, i) => {
            return (
              <div className='flex col-12 mt1 items-center' key={items.id}>
                <span className='col-2 font-dark-gray h5 weight-500 mr2'>
                  <Toggle state={items.isActive} onClick={() => toggelIsEnabled(i)} />
                </span>
                <span className='col-6 font-dark-grey h5 weight-500 mr2'>
                  {' '}
                  {items.riderType ? items.riderType : 'No data'}
                </span>
                <span className='col-8 font-dark-grey h5 weight-500 mr2'>
                  <input
                    className='form-control rounded p1 h4 mt02 border-light-grey4'
                    type='text'
                    defaultValue={items.description}
                    onChange={e => updateDescription(e.target.value, i)}
                  />
                </span>
                <span className='col-8 font-dark-grey h5 weight-500 mr2'>
                  <input
                    style={{ width: '100px' }}
                    className='form-control rounded p1 h4 mt02 border-light-grey4'
                    type='text'
                    defaultValue={items.fare.toString()}
                    onChange={e => updateFare(parseFloat(e.target.value), i)}
                  />
                </span>
              </div>
            )
          })}
        </div>
      </div>
      // </form>
    )
  }

  return <div />
}

export default ServiceEditPassengerType



// WEBPACK FOOTER //
// ./src/components/services/edit/ServiceEditPassengerType.tsx